module.exports = __webpack_public_path__ + "static/media/bonus.8d071f01.png";